import SnapShot from '../reporting/SnapShot';
import Equipment from '../location_admin/Equipment';
import ReportsHome from '../reporting/ReportsHome';
import LocationHome from '../location_admin/LocationHome';
import DashBoard from '../home/home';
import MemberHome from '../members/MemberHome';
import { SupportedIcons } from '../common/Icon';
import MisUse from '../washx/MisUse';
import Member from '../members/Member';
import WashX from '../washx/WashXHome';
import SupportHome from '../support/SupportHome';
import TestingHome from '../testing/TestingHome';
import QueryDash from '../reporting/Query';
import { IPermissionChecker } from '../_types/user';
import AdminHome from '../admin/AdminHome';
import AdminPolicy from '../admin/AdminPolicy';
import AdminMarketing from '../admin/AdminMarketing';
import BulkUtilities from '../admin/BulkUtilities';

export interface INavMenuGroup {
  key: string;
  label: string;
  path: string;
  iconName: SupportedIcons;
  items: INavMenuitem[];
  exact?: boolean | null;

  checkPermission?: IPermissionChecker;
};
export interface INavMenuitem {
    key: string;
    iconName: SupportedIcons;
    label: string;
    path: string;
    component: any;
    exact?: boolean | null;
    link: boolean;
    external?: string;
    checkPermission?: IPermissionChecker;

};



const _locationOnly: IPermissionChecker = async (src, setSrc) => { 
    return new Promise((resolve) => {
        resolve(src.currentLocation !== undefined && src.currentLocation !== null && src.role === 4);
    });
};
const _isOwnerAdminSalesSupport: IPermissionChecker = (src, setSrc) => {
    return new Promise((resolve) => {
        resolve((src.role !== undefined) && [3,4,5,6].find(e => e === src.role) !== undefined);
    })
};
const _isAdmin: IPermissionChecker = (src, setSrc) => {
    return new Promise((resolve) => {

        resolve(src.role === 4);
    });
};

const _testMode: IPermissionChecker = (src, setSrc) => {

    return new Promise((resolve) => {
        let client = process.env.REACT_APP_TEST_MODE !== "live";
        resolve(client);
    });

}

const _dashBoardUrl = (): string => {
    let toReturn = process.env.REACT_APP_LEGACY_DASHBOARD_URL;
    if (!toReturn) {
        toReturn = "/";
    }
    return toReturn;
}

export const GetMenu = (): INavMenuGroup[] => {

    const toReturn: INavMenuGroup[] = [
        { path: '/', key: 'Dashboard', label: 'Insights', iconName: SupportedIcons.DashBoard, checkPermission: _isAdmin, 
            items: [
                { path: '/', key: 'Home', iconName: SupportedIcons.DashBoard, label: 'Dashboard', component: DashBoard, exact:true, link:true }                
            ]
        },
        { path: '/reports/home', key: 'Reports', label: 'Reports', iconName: SupportedIcons.Assessment, checkPermission: _isAdmin,  
            items: [
                { path: '/reports/home', key: 'Home', iconName: SupportedIcons.Assessment, label: 'By Day', component: ReportsHome, link:true},
                { path: '/reports/snapshot', key: 'SnapShot', iconName: SupportedIcons.PieChart, label: 'SnapShot', component: SnapShot, link:true},
                { path: '/reports/query', key: 'Query', iconName: SupportedIcons.QueryList, label: 'Query', component: QueryDash, link:true},
            ]
        },
        { path: '/locations/home', key: 'Locations', label: 'Location', iconName: SupportedIcons.LocalCarWash, checkPermission: _locationOnly, 
        items: [
            { path: '/locations/home', key: 'Home', iconName: SupportedIcons.LocalCarWash, label: 'Location', component: LocationHome, link: true},
            { path: '/locations/equipment', key: 'Equipment', iconName: SupportedIcons.Router, label: 'Equipment', component: Equipment, link: true, exact: true, checkPermission: _isAdmin },
            { path: '/locations/equipment/:id', key: 'Equipment', iconName: SupportedIcons.Router, label: 'Equipment', component: Equipment, link: false, exact: true},
        ]
        },
        { path: '/members/home', key: 'Members', label: 'Members', iconName: SupportedIcons.Member, checkPermission: _isAdmin,
            items: [
                { path: '/members/home', key: 'MemberHome', iconName: SupportedIcons.Member, label: 'Dashboard', component: MemberHome, exact:true, link:true },
                { path: '/members/member/:id', key: 'MemberDetails', iconName: SupportedIcons.Member, label: 'Member Details', component: Member, exact:true, link:false, checkPermission: _isAdmin }                                
            ]
        },
        { path: '/washx/home', key: 'WashX', label: 'WashX', iconName: SupportedIcons.WashX, checkPermission: _isAdmin,
            items: [
                { path: '/washx/home', key: 'WashX', iconName: SupportedIcons.WashX, label: 'WashX', component: WashX, exact:true, link:true },
                { path: '/washx/misuse', key: 'MemberMisUse', iconName: SupportedIcons.MemberMisUse, label: 'MisUse', component: MisUse, exact:true, link:true, checkPermission: _isAdmin },      
            ]
        },
        { path: '/support/home', key: 'SupportHome', label: 'Support', iconName: SupportedIcons.Support, checkPermission: _isAdmin,
            items: [
                { path: '/support/home', key: 'SupportHome', iconName: SupportedIcons.Support, label: 'Support', component: SupportHome, exact:true, link:true },
            ]
        },
        { path: '/testing/home', key: 'TestingHome', label: 'Testing', iconName: SupportedIcons.Testing, checkPermission: _testMode,
            items: [
                { path: '/testing/home', key: 'TestingHome', iconName: SupportedIcons.Testing, label: 'Support', component: TestingHome, exact:true, link:true },
            ]
        },
        { path: '/admin/home', key: 'AdminHome', label: 'Admin', iconName: SupportedIcons.Admin, checkPermission: _isAdmin,
            items: [
                { path: '/admin/home', key: 'AdminHome', iconName: SupportedIcons.Admin, label: 'Admin', component: AdminHome, exact:true, link:true },
                //! link false seems to cause the entire thing to simply not appear.  It allows other sites to be able to route to this link
                { path: '/admin/marketing', key: 'Marketing', iconName: SupportedIcons.Edit, label: 'Marketing', component: AdminMarketing, exact:true, link:true, checkPermission: _isAdmin },
                { path: '/admin/policy', key: 'AdminPolicy', iconName: SupportedIcons.Admin, label: 'Admin Policy', component: AdminPolicy, exact:true, link:true, checkPermission: _isAdmin },
                { path: '/admin/bulk_utilities', key: 'BulkUtilities', iconName: SupportedIcons.Admin, label: 'Bulk Utilities', component: BulkUtilities, exact:true, link:true, checkPermission: _isAdmin },
            ]
        },
        { path: '/returnToDashboard', key: 'DashBoard', label: 'DashBoard', iconName: SupportedIcons.Legacy_Dashboard, checkPermission: _isAdmin,
            items: [
                { path: '/returnTodashboard', key: 'DashBoard', iconName: SupportedIcons.Legacy_Dashboard, label: 'DashBoard', component: DashBoard, exact:true, link:true, external: _dashBoardUrl() },
            ]
        },

        
    ];


    return toReturn;

}